import { GENDER_IDENTITY } from '../../models/registration/Registration'
import { REGISTRATION_EVENTS } from '../common/constants/mixpanelConstants'

export const genderIdentityOptionsList = [
  GENDER_IDENTITY.MALE,
  GENDER_IDENTITY.FEMALE,
  GENDER_IDENTITY.TRANSGENDER,
  GENDER_IDENTITY.NON_BINARY,
  GENDER_IDENTITY.OTHER,
  GENDER_IDENTITY.PREFER_NOT_TO_SAY,
]

export enum IDENTITY_PROVIDERS {
  GOOGLE = 'google',
  APPLE = 'apple',
  PARTNER = 'partner',
  NONE = 'none',
}

export const REGISTRATION_SUCCESS_EVENT_MAP: Record<IDENTITY_PROVIDERS, string> = {
  [IDENTITY_PROVIDERS.APPLE]: REGISTRATION_EVENTS.REGISTRATION_APPLE_SSO_SUCCESS,
  [IDENTITY_PROVIDERS.GOOGLE]: REGISTRATION_EVENTS.REGISTRATION_GOOGLE_SSO_SUCCESS,
  [IDENTITY_PROVIDERS.PARTNER]: REGISTRATION_EVENTS.REGISTRATION_PARTNER_SSO_SUCCESS,
  [IDENTITY_PROVIDERS.NONE]: REGISTRATION_EVENTS.REGISTRATION_SUCCESS,
}

export enum EmailClient {
  APPLEMAIL = 'mail',
  GMAIL = 'gmail',
  YAHOO = 'yahoo',
  OUTLOOK = 'outlook',
}

export const DEFAULT_MAX_CHILD_COUNT = 10

export const REGISTRATION_ENTRY_POINT_KEY = 'entryPoint'

export enum CODE_STATUS {
  INVALID = 'INVALID',
  EXPIRED = 'EXPIRED',
}

export const AUTO_ENROLLMENT_TOKEN_PARAM = 'token'
export const AUTO_ENROLLMENT_CUSTOMER_PARAM = 'customer' // customer is explicitly passed to the URL instead of relying on parsing customer from URL domain
export const DBT_REFERRAL_TOKEN_PARAM = 'token'

export const INVALID_CODE_STATUSES = new Set(['USED', 'WRONG_EMAIL', 'INVALID', 'NOT_FOUND'])

export const REGISTRATION_QUERY_PARAMS = {
  ID: 'id',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  IS_SSO: 'isSSO',
  CONNECTED_SERVICE: 'connectedService',
  TOKEN: 'token',
  DEVICE_UUID: 'deviceUUID',
  PARTNER_SSO_REGISTRATION_VERIFICATION_KEY_QUERY_PARAM: 'partnerSsoVerificationKey',
  PARTNER_SSO_REGISTRATION_PARTNER_IDP_QUERY_PARAM: 'partnerIdp',
  REDIRECT: 'redirect',
}
